import Landing from '@/services/Landing.js'

export default {
  async getLanding({ dispatch }, id) {
    const response = await Landing.getLanding(id)
    const landing = response.data.data.page
    if (!landing) {
      throw new Error()
    }

    dispatch('landing/setPageCategory', landing.category, { root: true })
    dispatch('landing/setPageType', landing.type, { root: true })
    dispatch('landing/setLanding', landing.draft, { root: true })
    dispatch('landing/setName', landing.name, { root: true })
    dispatch('landing/setTitle', landing.title, { root: true })
    dispatch('landing/setPublish', landing.published, { root: true })
    dispatch('settings/setSettings', landing.settings, { root: true })
  },

  saveDraft({ dispatch }, { id = '', draft = [], settings = {} }) {
    return Landing.setDraft(id, { draft, settings }).then(res => {
      dispatch('history/hasUnsaveChanges', false, { root: true })
      return res
    })
  },

  saveLanding(
    { dispatch },
    { id = '', landing = [], settings = {}, preCompiled = '', compiled = '', published = false }
  ) {
    return Landing.setLanding(id, { landing, settings, preCompiled, compiled, published }).then(res => {
      dispatch('history/hasUnsaveChanges', false, { root: true })
      return res
    })
  },
}
